<!-- Liste des résultats -->
<div [ngClass]="{ hidden: visuGrid === 2}">
  <!-- Ne met pas la classe qd la condition est vérifée -->
  @if (resultDisplay.length !== 0) {
    <field-tools [dataTitle]="titleDetail">
      @if (fetchParam.displayNext === true) {
        <!-- <dm-fieldset-button [backGround]="false"> -->
          <button pButton type="button" icon="pi pi-forward" class="margin cust-width p-button-primary"
            pTooltip="{{'Find_Next' | translate}}"
            (click)="goNextDocs()"
          ></button>
        <!-- </dm-fieldset-button> -->
      }
      <dm-fieldset-header [backGround]="false">
        @if (btnAction === true) {
          <btntools
            [hideButton]="hideButton"
            [btnToolList]="btGridActionList"
            (clickButton)="onClickGridActionList($event)"
          ></btntools>
        }
      </dm-fieldset-header>
      <displayresultgrid
        #displayresultgrid
        [originClick]="originClick"
        [modeView]="modeView"
        [modeDetail]="modeDetail"
        [srchMode]="srchMode"
        [hasLock]="hasLock"
        [listColumns]="listColumnsWrk"
        [resultDisplay]="resultDisplay"
        [currentUser]="currentUser"
        [splitId]="splitId"
        [pathPdf]="pathPdf"
        [paramDetail]= "paramDetail"
        [fetchParam]="fetchParam"
        (onClickItem)="clickline($event)"
        (onClickcolpdf)="clickcolpdf($event)"
        (onPageChange)="onPageChange($event)"
        (onShowModal)="showModal($event)"
        >
      </displayresultgrid>
      @if (modeView === 'T') {
        <thumbs
          #thumb
          [thumbSize]="sizeThumb"
          [hasLock]="hasLock"
          [thumbList]="resultDisplay"
          [infoList]="infoList"
          [currentUser]="currentUser"
          (clickImg)="onClickImg($event)"
          >
        </thumbs>
      }
    </field-tools>
  }
</div>
<!-- Détail d'un document -->
 @if (visuGrid === 2) {
   <div class="grid col-12 md:col-12 lg:col-12">
     <div class="col-12 md:col-12 lg:col-12">
       @if (currentVer === '0000') {
         <documentdetail
           #documentDetail
           [displayReorg]="displayReorg"
           [editMode]=true
           [addNotif]="addNotif"
           [paramDetail]= "paramDetail"
           [userList]= "userList"
           [basketMoveAll]= "basketMoveAll"
           (onUpdate)="updateIndex('', false)"
           (onUpdateAtf)="refreshAtf($event)"
           (onUpdateVer)="refreshVer($event)"
           (onViewVer)="viewVer($event)"
           (onReadVer)="readVer($event)"
           (onSaveComment)="saveComment($event)"
           (onOutComment)="outComment($event)"
           (onSaveMail)="onClickSaveMail($event)"
           (onApplyAction)="onApplyAction($event)"
           (onAddItem)="addItem($event)"
           (onDelItem)="delItem($event)"
           (onChangeTab)="onChangeTab($event)"
           (onClickMainImg)="onClickMainImg($event)"
           (onRightClick)="onRightClick($event)"
           (onClickDocActionList)="onClickDocActionList($event)"
           (onClickSaveDock)="saveDock($event)"
           (onSelectBasketTransfert)="selectBasketTransfertDock($event)"
           (onClickAtfGed)="clickAtfGed($event)"
           >
         </documentdetail>
       }@else {
         <documentdetailversion
           [rightService]="rightService"
           [viewIndex]="viewIndex"
           [docInfos]="docInfosVer"
           [docIndexFiltered]="docIndexFilteredVer"
           [docVersion]="docVersion"
           [currentDocId]="docIdVer"
           [isLock]="isLock"
           [numVer]="currentVer"
           [nbZoneDisplay]="nbZoneDisplay"
           (onViewVer)="viewVer($event)"
           >
         </documentdetailversion>
       }
     </div>
   </div>
 }

<exportdocs [visible]="displayExport" [selectedDocs]="selectedDocsExport" (onClose)="closeExport()"> </exportdocs>

<senddocsmail [visible]="displaySendMail" [selectedDocs]="selectedDocsExport" (onClose)="closeSendMail()">
</senddocsmail>

@if (displayStat === true) {
  <statdocs [visible]="displayStat" [request]="request" (onClose)="closeStat()"> </statdocs>
}

@if (displayChangeDoc === true) {
  <changedocs
    [visible]="displayChangeDoc"
    [selectedDocs]="selectedDocsExport"
    (onClickChangeDoc)="onClickChangeDoc($event)"
    (onClose)="closeChangeDoc()"
    >
  </changedocs>
}

<actionsdoc
  [visible]="displayActions"
  [action]="currentActionDoc"
  [position]="pos"
  [dimension]="dimension"
  [numPage]="numPage"
  [docInfos]="docInfos"
  [stamp]="currentStamp"
  [userInfos]="userInfos"
  [bskMode]="bskMode"
  (onRefresh)="refreshActions($event)"
  (onClose)="closeActions($event)"
  >
</actionsdoc>

<p-dialog
  [contentStyle]="{ overflow: 'auto' }"
  [styleClass]="'sm:col-12 md:col-6 lg:col-4 xl:col-4'"
  [(visible)]="displayRename"
  [modal]="true"
  [closable]="true"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Ren_Doc' | translate}}
    </span>
  </ng-template>
  <div class="col-12">
    <input
      [(ngModel)]="newDocName"
      class="p-inputtext size_cent"
      pInputText
      type="text"
      maxlength="64"
      autofocus
      />
    </div>
    <div class="col-12 md:col-12 align-right">
      <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeRename()" label="{{'Cancel' | translate}}"></button>
      <button type="button" pButton class="margin" (click)="onClickRename()" label="{{'Save' | translate}}"></button>
    </div>
  </p-dialog>

  <deletedocs
    [actionGroup]="actionGroup"
    [selectedDocs]="selectedDocsExport"
    [visible]="displayDelDocs"
    [bskMode]="bskMode"
    [currentSelectedBsk]="currentSelectedBsk"
    [titleDelete]="titleDelete"
    [isAdmin]="isAdmin"
    [docBasket]="docBasket"
    (onCloseDialog)="closeDialog($event)"
    (onCloseIndex)="closeDelDocs($event)"
    (onClickDeleteDoc)="onClickDeleteDoc($event)"
    >
  </deletedocs>

  @if (displayMove === true) {
    <movedocs
      [currentAction]="currentAction"
      [visible]="displayMove"
      [bskMode]="bskMode"
      [currentSelectedBsk]="currentSelectedBsk"
      [basketMoveAll]="basketMoveAll"
      [atfName]="currentAtf"
      [docId]="currentDocId"
      [actionGroup]="actionGroup"
      (onSelectBasketTransfert)="selectBasketTransfert($event)"
      (onClose)="closeMove('validation')"
      >
    </movedocs>
  }

  @if (displayVersion === true) {
    <versiondoc
      [docId]="currentDocId"
      [visible]="displayVersion"
      (onClose)="closeVersion($event)"
      >
    </versiondoc>
  }

  @if (displayCompose === true) {
    <composition-pdf
      [docId]="currentDocId"
      [currentSelectedBsk]="currentSelectedBsk"
      [visible]="displayCompose"
      (onClose)="closeCompose($event)"
      >
    </composition-pdf>
  }
  
  @if (displayIndexTransfert === true) {
    <transbsk
      [currentAction]="currentAction"
      [visible]="displayIndexTransfert"
      [bskMode]="bskMode"
      [currentSelectedBsk]="currentSelectedBsk"
      [currentTransfertBsk]="currentTransfertBsk"
      [infosMail]="infosMail"
      [displayDate]="true"
      [nbDoc]="nbDoc"
      [actionGroup]="actionGroup"
      [docIdList]="docIdList"
      [docIndex]="docIndex"
      [sendToBsk]="sendToBsk"
      [currentAtf]="currentAtf"
      [internalPrefUsr]="internalPrefUsr"
      (onAction)="actionTrans($event)"
      (onSwitchTransfert)="switchTransfert()"
      (onClose)="closeTrans($event)"
      >
    </transbsk>
  }

  <p-dialog
    [contentStyle]="{ overflow: 'visible', 'max-width': '55vw' }"
    [styleClass]="'sm:col-12 md:col-12 lg:col-7 xl:col-6'"
    [(visible)]="displayInfo"
    [modal]="true"
    [closable]="false"
    >
    <ng-template pTemplate="header">
      <span class="p-dialog-title">
        {{'Enter_Mail' | translate}}
      </span>
    </ng-template>
    <div class="grid">
      <div class="col-12">{{'Bsk_Cur' | translate}} {{ currentSelectedBsk.bskLabel }}</div>
      <div class="col-12">
        <infosmail [visuMode]="false" [bskTypeMail]="true" [editMode]="true" [infosMailDisplay]="infosMail" ></infosmail>
      </div>
      <div class="col-12 md:col-12 align-right">
        <button type="button" pButton class="margin" (click)="onClickSaveInfoMail()" label="{{'Save' | translate}}"></button>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    [contentStyle]="{ overflow: 'visible', 'max-width': '55vw' }"
    [styleClass]="'sm:col-12 md:col-12 lg:col-7 xl:col-6'"
    [(visible)]="displayComm"
    [modal]="true"
    [closable]="false"
    >
    <ng-template pTemplate="header">
      <span class="p-dialog-title">
        {{'Com_Save' | translate}}
      </span>
    </ng-template>
    <div class="grid">
      @if (bskMode === true) {
        <div class="col-12">{{'Bsk_Cur' | translate}} {{ currentSelectedBsk.bskLabel }}</div>
      }
      <div class="col-12">
      </div>
      <div class="col-12 md:col-12 align-right">
        <button type="button" pButton class="margin" (click)="onClickSaveComm(false, true)" label="{{'Cancel' | translate}}"></button>
        <button type="button" pButton class="margin" (click)="onClickSaveComm(true, true)" label="{{'Save' | translate}}"></button>
      </div>
    </div>
  </p-dialog>

  <app-item-confirm [key]="'warning'" [severity]="'warning'" (onAccept)="updateIndex('', false)"></app-item-confirm>
  <app-item-confirm [header]="lockHeader" [key]="'lock'" [severity]="'warning'"></app-item-confirm>
